import { render, staticRenderFns } from "./dashboardUnidadesObjetivos.vue?vue&type=template&id=48a21507&"
import script from "./dashboardUnidadesObjetivos.vue?vue&type=script&lang=js&"
export * from "./dashboardUnidadesObjetivos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports